module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'news-component_is-loading': _vm.isLoading
    }
  }, [_c('div', {
    staticClass: "tabs tabs_center",
    attrs: {
      "role": "tablist"
    }
  }, _vm._l((this.tabList), function(item) {
    return _c('a', {
      key: item.id,
      staticClass: "tab tabs__item",
      class: {
        'is-active': item.isActive,
          'is-loading': item.isActive && _vm.isLoading,
          'is-disabled': _vm.isLoading
      },
      attrs: {
        "role": "tab",
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setActiveTab(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "tab__title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "badge tab__badge"
    }, [_vm._v(_vm._s(item.total))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "news-tiles mt-2.25"
  }, [_c('div', {
    staticClass: "news-tiles__container"
  }, [(!_vm.hasErrors) ? _c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((this.newsList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "news-tiles__tile"
    }, [_c('div', {
      staticClass: "news-tile"
    }, [_c('article', {
      staticClass: "news"
    }, [_c('time', {
      staticClass: "news__date",
      attrs: {
        "datetime": item.date
      }
    }, [_vm._v(_vm._s(item.formattedDate))]), _vm._v(" "), _c('h2', {
      staticClass: "news__title"
    }, [_c('a', {
      staticClass: "news__link",
      attrs: {
        "href": item.link
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "news__content"
    }, [_vm._v(_vm._s(item.text))])])])])
  })) : _vm._e(), _vm._v(" "), (_vm.hasErrors) ? _c('div', {
    staticClass: "alert alert_danger"
  }, [_vm._v(_vm._s(_vm.statusMsg))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "news-tiles__footer"
  }, [(_vm.moreExists && !_vm.hasErrors) ? _c('button', {
    staticClass: "btn btn_outline",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.addNews
    }
  }, [_vm._v("Показать еще\n      ")]) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30fc8bf3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30fc8bf3","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/News/News.vue
// module id = 134
// module chunks = 0